import React, { SyntheticEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import DeleteButton from '@components/DeleteButton';
import Input from '@components/Form/Input';
import { ProductListAdUrlInput } from "@api/graphql/types";

interface Props {
    name: string;
    value: ProductListAdUrlInput[];
    onChange: (value: ProductListAdUrlInput[], name: string) => void;
    errorMessage: string | null;
}

const MAX_POSITION: number = 24;

class UrlsForm extends React.Component<Props & InjectedIntlProps> {
    private readonly positionsArray: Array<{ value: string | number, label: string }> = Array.from(Array(MAX_POSITION).keys()).map(position => {
        position++;
        return {
            value: position,
            label: `${position}`,
        };
    });

    private add = (e: SyntheticEvent) => {
        e.preventDefault();
        const value = [...(this.props.value || []), { url: "", position: 1 }];
        this.props.onChange(value, this.props.name);
    }

    private remove = (index: number) => {
        const value = [...(this.props.value || [])];
        value.splice(index, 1);
        this.props.onChange(value, this.props.name);
    }

    private onUrlChange = (index: number) => (url: string) => {
        const value = [...(this.props.value || [])];
        value[index].url = url;
        this.props.onChange(value, this.props.name);
    }

    private onPositionChange = (index: number) => (position: number) => {
        const value = [...(this.props.value || [])];
        value[index].position = position;
        this.props.onChange(value, this.props.name);
    }

    private renderValue = (): JSX.Element[] | null => {
        if (!this.props.value) {
            return null;
        }
        return this.props.value.map((item, index) => {
            return (
                <div className="row" key={index}>
                    <div className="col-sm-8">
                        <Input
                            type="text"
                            name="urls"
                            value={item.url}
                            onChange={this.onUrlChange(index)}
                            hint={this.props.intl.formatMessage({ id: 'module.productListAd.url.hint.url' })}
                            required={true}
                        />
                    </div>
                    <div className="col-sm-2">
                        <Input
                            type="select"
                            name="position"
                            value={item.position}
                            onChange={this.onPositionChange(index)}
                            options={this.positionsArray}
                            isClearable={false}
                            required={true}
                            hint={this.props.intl.formatMessage({ id: 'module.productListAd.url.hint.position' })}
                        />
                    </div>
                    <div className="col-sm-2">
                        <DeleteButton className="btn-block" onClick={this.remove} value={index} />
                    </div>
                </div>
            );
        });
    }

    private renderErrorMessage = (): JSX.Element | null => {
        return this.props.errorMessage ? (
            <div className="row">
                <div className="alert alert-info">
                    {this.props.errorMessage}
                </div>
            </div>
        ) : null;
    }

    private renderActionButtons = (): JSX.Element => {
        const { intl, name, onChange } = this.props;

        return (
            <>
                <div className="row">
                    <div className="col-sm-4">
                        <button className="btn btn-primary btn-block" onClick={this.add}>{intl.formatMessage({ id: 'common.add' })}</button>
                    </div>
                    <div className="col-sm-4">
                        <DeleteButton className="btn-block" onClick={() => { onChange([], name); }}>{this.props.intl.formatMessage({ id: 'module.productListAd.urls.deleteAll' })}</DeleteButton>
                    </div>
                </div>
            </>
        );
    }

    public render() {
        return (
            <>
                {this.renderErrorMessage()}
                {this.renderValue()}
                {this.renderActionButtons()}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(UrlsForm);



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/components/UrlsForm.tsx